module.exports = __webpack_public_path__ + "fonts/DIN-Bold.20720c3a.otf";